export default "__VITE_PUBLIC_ASSET__cf6e4c70__"